
import { supabase } from "@/integrations/supabase/client";

/**
 * Script to update all users' subscription status to "Free (Forever)"
 * This ensures consistency with the subscription_plans table naming
 */
export const updateAllUsersToFreePlan = async (): Promise<{
  success: boolean;
  message: string;
  count?: number;
}> => {
  try {
    console.log("Starting migration: Update all users to Free (Forever) plan");
    
    // First, verify that the "Free (Forever)" plan exists in subscription_plans
    const { data: freePlan, error: planError } = await supabase
      .from('subscription_plans')
      .select('id, name')
      .eq('name', 'Free (Forever)')
      .single();
    
    if (planError || !freePlan) {
      console.error("Error: Free (Forever) plan not found", planError);
      return {
        success: false,
        message: "Free (Forever) plan not found in subscription_plans table"
      };
    }
    
    console.log("Found Free plan:", freePlan);
    
    // Update all user_subscriptions to use the Free (Forever) plan
    const { data, error, count } = await supabase
      .from('user_subscriptions')
      .update({
        subscription_status: freePlan.name, // Use the exact plan name from the database
        plan_id: freePlan.id,
        updated_at: new Date().toISOString()
      })
      .neq('subscription_status', freePlan.name);
    
    if (error) {
      console.error("Error updating user subscriptions:", error);
      return {
        success: false,
        message: `Error updating user subscriptions: ${error.message}`
      };
    }
    
    console.log(`Successfully updated ${count || 0} user subscriptions to ${freePlan.name}`);
    
    return {
      success: true,
      message: `Successfully updated ${count || 0} user subscriptions to ${freePlan.name}`,
      count: count || 0
    };
  } catch (err) {
    console.error("Exception in updateAllUsersToFreePlan:", err);
    return {
      success: false,
      message: `Exception in migration: ${err instanceof Error ? err.message : String(err)}`
    };
  }
};
